var $ = require("jquery");
$(document).ready(() => {
  $(".header__hamburger").click(function(e) {
    e.preventDefault();
    $(this).toggleClass("header__hamburger--is-active");
    $(".hamburger__inner").toggleClass("hamburger__inner--is-animate");
    $("body").toggleClass("disable-scroll");
    $(".main-navigation").toggleClass("main-navigation--is-active");
    $(".header__navigation").toggleClass("header__navigation--is-active");
    $(".header__search").toggleClass("header__search--is-hidden");
  });

  $(".menu-item-has-children .main-navigation__link").click(function(e) {
    if (window.innerWidth > 1023) {
      return;
    }
    e.preventDefault();
    $(this)
      .parent()
      .toggleClass("main-navigation__item--is-active");

    if (
      $(this)
        .parent()
        .hasClass("main-navigation__item--is-active")
    ) {
      if ($(this).attr("href") === "#") {
        return;
      }

      $(this)
        .clone()
        .removeClass("main-navigation__link")
        .addClass(
          "main-navigation__sub__link main-navigation__sub__link--is-cloned"
        )
        .prependTo(
          $(this)
            .parent()
            .find(".main-navigation__sub")
        )
        .wrap("<li class='main-navigation__sub__item'></li>");
    } else {
      $(this)
        .parent()
        .find(".main-navigation__sub__link--is-cloned")
        .parent()
        .remove();
    }
  });
});

$(window).on("resize", function() {
  if (window.innerWidth > 1023) {
    $(".main-navigation__sub__link--is-cloned")
      .parent()
      .remove();
    $(this).removeClass("header__hamburger--is-active");
    $(".hamburger__inner").removeClass("hamburger__inner--is-animate");
    $("body").removeClass("disable-scroll");
    $(".main-navigation").removeClass("main-navigation--is-active");
    $(".main-navigation__item").removeClass("main-navigation__item--is-active");
    $(".header__navigation").removeClass("header__navigation--is-active");
    $(".header__search").removeClass("header__search--is-hidden");
  }
});
